export default __webpack_public_path__ + "static/logo-chat-28a8f210fc1e619ee493a059b85b8c63.svg";